module.exports = __webpack_public_path__ + "img/4x.2217a2ca.png";